export const SIDENAV_DEFAULT_WIDTH = 256;
export const SIDENAV_MIN_WIDTH = 200;
export const SIDENAV_MAX_WIDTH = 400;
export const SIDENAV_COLLAPSED_WIDTH = 60;

// When resizing, allow the sidenav to "snap" to it's default width when falling within +/- this value
export const SIDENAV_RESIZE_SNAP_WINDOW = 12;

export const TOGGLE_COLLAPSE_EVENT = `toggleCollapse`;

export enum TrackingEvent {
  ExpandedSection = `Expanded Subsection`,
  CollapsedSection = `Collapsed Subsection`,
  ExpandedItem = `Expanded Item`,
  CollapsedItem = `Collapsed Item`,
  ExpandedSidenav = `Expanded Sidenav`,
  CollapsedSidenav = `Collapsed Sidenav`,
  Resize = `Resize`,
  Reorder = `Reorder`,
}

export enum DropPosition {
  Above,
  Below,
}

export enum ScrollPosition {
  Top = `top`,
  Scrolling = `scrolling`,
  Bottom = `bottom`,
  // None means that the sectionEl element has few elements and doesn't need scroll
  None = `none`,
}
